export const CRM_CONTACTS_RESET_STATE = 'CRM_CONTACTS_RESET_STATE';
export const CRM_CONTACTS_CURRENT_ITEM = 'CRM_CONTACTS_CURRENT_ITEM';

export const CRM_CONTACTS_REQUEST_LOADING = 'CRM_CONTACTS_REQUEST_LOADING';
export const CRM_CONTACTS_REQUEST_SUCCESS = 'CRM_CONTACTS_REQUEST_SUCCESS';
export const CRM_CONTACTS_REQUEST_FAILED = 'CRM_CONTACTS_REQUEST_FAILED';

export const CRM_CONTACTS_CURRENT_ACTION = 'CRM_CONTACTS_CURRENT_ACTION';
export const CRM_CONTACTS_RESET_ACTION = 'CRM_CONTACTS_RESET_ACTION';